import { OrderCancellationAnalyticsPage } from '@/pages/OrderCancellationAnalytics/OrderCancellationAnalyticsPage';
import { MediaLibraryPage } from '@/pages/MediaLibrary/MediaLibraryPage';
import { ChatReplyTemplatesPage } from '@/pages/ChatReplyTemplates/ChatReplyTemplatesPage';
import { CacheManagementPage } from '@/pages/CacheManagement';
import { MessageTemplateGroupsPage, MessageTemplateGroupPage, MessageTemplateFormPage } from '@/pages/MessageTemplates';
import { PushTestsPage } from '@/pages/PushTests';
import { VoxSettingsPage } from '@/pages/VoxSettings';
import { SchedulerPage, CronJobDetailsPage, CronJobFormPage } from '@/pages/Scheduler';
import { PromotionBannerTemplates } from '@/pages/PromotionBannerTemplates';
import { PromotionBannerTemplateForm, } from '@/pages/PromotionBannerTemplates';
import { PromotionBannerTemplateDetails } from '@/pages/PromotionBannerTemplates';

import { Navigate } from 'react-router';
import type { RouteProps } from 'react-router-dom';

import { ApiUserRole, type ApiUserRole as ApiUserRoleType } from '@/core/generated/api';

import { AccessManagementPage } from '@/pages/AccessManagement';
import { TelegramSettingsForm } from '@/pages/TelegramSettings';
import { FeatureTogglesPage } from '@/pages/FeatureToggles';
import { MemoryDiagnosticsPage } from '@/pages/MemoryDiagnostics';
import { MessageSendStatisticsPage } from '@/pages/MessageSendStatistics';
import { OrderProblemsPage, OrderProblemDetailsPage } from '@/pages/OrderProblems';
import { ProblemAddressesPage, ProblemAddressDetailsPage } from '@/pages/ProblemAddresses';

import { Blogs } from '@/pages/Blogs';
import { BlogDetails } from '@/pages/Blogs';
import { BlogForm } from '@/pages/Blogs'

import { Products } from '@/pages/Products'
import { ProductDetails } from '@/pages/Products';
import { ProductForm } from '@/pages/Products';

import { Clients } from '@/pages/Clients';
import { ClientDetails } from '@/pages/Clients';
import { ClientForm } from '@/pages/Clients'

import { ClientSubscriptionDetails } from '@/pages/ClientSubscriptions';
import { ClientSubscriptionForm } from '@/pages/ClientSubscriptions';

import { ClientAddressDetails } from '@/pages/ClientAddress';
import { ClientAddressForm } from '@/pages/ClientAddress';

import { Executors } from '@/pages/Executors'
import { ExecutorDetails } from '@/pages/Executors';
import { ExecutorPassport } from '@/pages/Executors';
import { ExecutorForm } from '@/pages/Executors'

import { ExecutorAddressDetails } from '@/pages/ExecutorAddress';
import { ExecutorAddressForm } from '@/pages/ExecutorAddress';

import { Subscriptions } from '@/pages/Subscriptions'
import { SubscriptionDetails } from '@/pages/Subscriptions';
import { SubscriptionForm } from '@/pages/Subscriptions'

import { ChatPage } from '@/pages/Chats';
import { ChatDialogPage } from '@/pages/ChatDialogs';
import { UserChatsPage } from '@/pages/UserChats';

import { Orders } from '@/pages/Orders'
import { OrderDetails } from '@/pages/Orders'
import { OrderForm } from '@/pages/Orders'
import { CancelOrderForm } from '@/pages/Orders'

import { Policies } from '@/pages/Policies'
import { PolicyDetails } from '@/pages/Policies';
import { PolicyForm } from '@/pages/Policies';

import { PromoCodes } from '@/pages/PromoCodes'
import { PromoCodeDetails } from '@/pages/PromoCodes';
import { PromoCodeForm } from '@/pages/PromoCodes';
import { PromoCodeTemplatesPage, PromoCodeTemplateDetailsPage, PromoCodeTemplateFormPage } from '@/pages/PromoCodeTemplates';
import { PromoCodePrintingsPage, PromoCodePrintingDetailsPage } from '@/pages/PromoCodePrintings';

import { CashbackLevels } from '@/pages/CashbackLevels';
import { CashbackRulesPage } from '@/pages/CashbackRules';
import { CashbackLevelForm } from '@/pages/CashbackLevels';

import { BonusAccounts } from '@/pages/BonusAccounts';
import { BonusAccountDetails } from '@/pages/BonusAccounts';

import { PriceLists } from '@/pages/PriceLists'
import { PriceListDetails } from '@/pages/PriceLists';
import { PriceListForm } from '@/pages/PriceLists'

import { PetDetails } from '@/pages/Pets';
import { PetForm } from '@/pages/Pets';

import { Cities } from '@/pages/Cities';
import VoxServicesPage from '@/pages/VoxServices/VoxServicesPage';
import ProblemExecutorsPage from '@/pages/ProblemExecutors/ProblemExecutorsPage';

import DashboardPage from '@/pages/DashboardPage';

import { TaskIndexPage } from '@/pages/Tasks';
import { OperatorTasksPage } from '@/pages/OperatorTasks';

import { AppVersions } from '@/pages/AppVersions';
import { AppVersionDetails, } from '@/pages/AppVersions';
import { AppVersionForm } from '@/pages/AppVersions';

import { Tags } from '@/pages/Tags';
import { TagForm } from '@/pages/Tags';

import {
    UserDialogsPage,
    DialogTemplateFormPage,
    DialogBroadcastFormPage,
    DialogBroadcastDetailsPage,
} from '@/pages/UserDialogs';
import { NotificationTemplates } from '@/pages/NotificationTemplates';
import { NotificationTemplateDetails, } from '@/pages/NotificationTemplates';
import { NotificationTemplateForm } from '@/pages/NotificationTemplates';

export enum AppRoutes {
    PROMOTION_BANNER_TEMPLATES = 'promotionBannerTemplates',
    PROMOTION_BANNER_TEMPLATE_CREATE = 'promotionBannerTemplateCreate',
    PROMOTION_BANNER_TEMPLATE_EDIT = 'promotionBannerTemplateEdit',
    PROMOTION_BANNER_TEMPLATE_DETAILS = 'promotionBannerTemplateDetails',

    TASK_INDEX = 'taskIndex',
    OPERATOR_TASKS = 'operatorTasks',

    AUTH = 'auth',

    MAIN = 'main',

    CITIES = 'cities',

    CLIENTS = 'clients',
    CLIENT_DETAILS = 'clientDetails',
    CLIENT_CREATE = 'clientCreate',
    CLIENT_EDIT = 'clientEdit',

    CLIENT_SUBSCRIPTION_DETAILS = 'clientSubscriptionDetails',
    CLIENT_SUBSCRIPTION_CREATE = 'clientSubscriptionCreate',
    CLIENT_SUBSCRIPTION_EDIT = 'clientSubscriptionEdit',

    CLIENT_ADDRESS_DETAILS = 'clientAddressDetails',
    CLIENT_ADDRESS_CREATE = 'clientAddressCreate',
    CLIENT_ADDRESS_EDIT = "clientAddressEdit",

    EXECUTORS = 'executors',
    EXECUTOR_DETAILS = 'executorDetails',
    EXECUTOR_CREATE = 'executorCreate',
    EXECUTOR_EDIT = 'executorEdit',
    EXECUTOR_PASSPORT = 'executorPassport',

    EXECUTOR_ADDRESS_DETAILS = 'executorAddressDetails',
    EXECUTOR_ADDRESS_CREATE = 'executorAddressCreate',
    EXECUTOR_ADDRESS_EDIT = "executorAddressEdit",

    SUBSCRIPTIONS = 'subscriptions',
    SUBSCRIPTION_DETAILS = 'subscriptionDetails',
    SUBSCRIPTION_CREATE = 'subscriptionCreate',
    SUBSCRIPTION_EDIT = 'subscriptionEdit',

    CHATS = 'chats',
    CHAT_DIALOGS = 'chatDialogs',
    USER_CHATS = 'userChats',

    //PETS = 'pets',
    PET_DETAILS = 'petDetails',
    PET_CREATE = 'petCreate',
    PET_EDIT = 'petEdit',

    VOX_SERVICES = 'vox-services',

    BLOGS = 'blogs',
    BLOG_DETAILS = 'blogDetails',
    BLOG_CREATE = 'blogCreate',
    BLOG_EDIT = 'blogEdit',

    PRODUCTS = 'products',
    PRODUCT_DETAILS = 'productDetails',
    PRODUCT_CREATE = 'productCreate',
    PRODUCT_EDIT = 'productEdit',

    PROMO_CODES = 'promoCodes',
    PROMO_CODE_TEMPLATES = 'promoCodeTemplates',
    PROMO_CODE_TEMPLATE_DETAILS = 'promoCodeTemplateDetails',
    PROMO_CODE_TEMPLATE_CREATE = 'promoCodeTemplateCreate',
    PROMO_CODE_TEMPLATE_EDIT = 'promoCodeTemplateEdit',
    PROMO_CODE_PRINTINGS = 'promoCodePrintings',
    PROMO_CODE_PRINTING_DETAILS = 'promoCodePrintingDetails',
    PROMO_CODE_DETAILS = 'promoCodeDetails',
    PROMO_CODE_CREATE = 'promoCodeCreate',
    PROMO_CODE_EDIT = 'promoCodeEdit',

    CASHBACK_LEVELS = 'cashbackLevels',
    CASHBACK_LEVEL_CREATE = 'cashbackLevelCreate',
    CASHBACK_LEVEL_EDIT = 'cashbackLevelEdit',
    CASHBACK_RULES = 'cashbackRules',

    BONUS_ACCOUNTS = 'bonusAccounts',
    BONUS_ACCOUNT_DETAILS = 'bonusAccountDetails',

    ORDERS = 'orders',
    ORDER_PROBLEMS = 'orderProblems',
    ORDER_PROBLEM_DETAILS = 'orderProblemDetails',
    PROBLEM_ADDRESSES = 'problemAddresses',
    PROBLEM_EXECUTORS = 'problemExecutors',
    PROBLEM_ADDRESS_DETAILS = 'problemAddressDetails',
    ORDER_DETAILS = 'orderDetails',
    ORDER_CREATE = 'orderCreate',
    ORDER_EDIT = 'orderEdit',
    ORDER_CANCEL = 'orderCancel',

    POLICIES = 'policies',
    POLICY_DETAILS = 'policyDetails',
    POLICY_CREATE = 'policyCreate',
    POLICY_EDIT = 'policyEdit',

    PRICE_LIST_DETAILS = 'priceListDetails',
    PRICE_LISTS = 'priceLists',
    PRICE_LIST_CREATE = 'priceListCreate',
    PRICE_LIST_EDIT = 'priceListEdit',

    SETTINGS = 'settings',
    APPLICATION_SETTINGS = 'voxSettings',
    TELEGRAM_SETTINGS = 'telegramSettings',
    FEATURE_TOGGLES = 'featureToggles',
    CACHE_MANAGEMENT = 'cacheManagement',
    SCHEDULER = 'scheduler',
    CRON_JOB_DETAILS = 'cronJobDetails',
    CRON_JOB_EDIT = 'cronJobEdit',
    MEMORY_DIAGNOSTICS = 'memoryDiagnostics',
    MESSAGE_SEND_STATISTICS = 'messageSendStatistics',
    ORDER_CANCELLATION_ANALYTICS = 'orderCancellationAnalytics',
    PUSH_TESTS = 'pushTests',

    APP_VERSIONS = 'appVersions',
    APP_VERSION_DETAILS = 'appVersionDetails',
    APP_VERSION_EDIT = 'appVersionEdit',

    TAGS = 'tags',
    TAG_EDIT = 'tagEdit',

    MEDIA_LIBRARY = 'mediaLibrary',
    CHAT_REPLY_TEMPLATES = 'chatReplyTemplates',
    MESSAGE_TEMPLATES = 'messageTemplates',
    MESSAGE_TEMPLATE_GROUP = 'messageTemplateGroup',
    MESSAGE_TEMPLATE_EDIT = 'messageTemplateEdit',
    USER_DIALOGS = 'userDialogs',
    USER_DIALOG_TEMPLATE_NEW = 'userDialogTemplateNew',
    USER_DIALOG_TEMPLATE = 'userDialogTemplate',
    USER_DIALOG_BROADCAST_NEW = 'userDialogBroadcastNew',
    USER_DIALOG_BROADCAST = 'userDialogBroadcast',
    NOTIFICATION_TEMPLATES = 'notificationTemplates',
    NOTIFICATION_TEMPLATE_DETAILS = 'notificationTemplateDetails',
    NOTIFICATION_TEMPLATE_EDIT = 'notificationTemplateEdit',

    ACCESS_MANAGEMENT = 'accessManagement',

    NOT_FOUND = 'not_found',
}

export const RoutePath: Record<AppRoutes, string> = {
    [AppRoutes.MEDIA_LIBRARY]: '/media-library',
    [AppRoutes.CHAT_REPLY_TEMPLATES]: '/chat-message-templates',
    [AppRoutes.PROMOTION_BANNER_TEMPLATES]: '/promotion-banner-templates',
    [AppRoutes.PROMOTION_BANNER_TEMPLATE_CREATE]: '/promotion-banner-templates/new',
    [AppRoutes.PROMOTION_BANNER_TEMPLATE_EDIT]: '/promotion-banner-templates/:id/edit',
    [AppRoutes.PROMOTION_BANNER_TEMPLATE_DETAILS]: '/promotion-banner-templates/:id',

    [AppRoutes.TASK_INDEX]: '/tasks',
    [AppRoutes.OPERATOR_TASKS]: '/operator-tasks',
    [AppRoutes.AUTH]: '/auth',

    [AppRoutes.MAIN]: '/',
    [AppRoutes.CITIES]: '/cities',

    //[AppRoutes.PETS]: '/pets',
    [AppRoutes.PET_DETAILS]: '/pets/:id',
    [AppRoutes.PET_CREATE]: '/pets/new',
    [AppRoutes.PET_EDIT]: '/pets/:id/edit',

    [AppRoutes.CLIENTS]: '/clients',
    [AppRoutes.CLIENT_CREATE]: '/clients/new',
    [AppRoutes.CLIENT_EDIT]: '/clients/:id/edit',
    [AppRoutes.CLIENT_DETAILS]: '/clients/:id',

    [AppRoutes.CLIENT_ADDRESS_CREATE]: '/client-address/new',
    [AppRoutes.CLIENT_ADDRESS_DETAILS]: '/client-address/:id',
    [AppRoutes.CLIENT_ADDRESS_EDIT]: '/client-address/:id/edit',

    [AppRoutes.CLIENT_SUBSCRIPTION_CREATE]: '/client-subscriptions/new',
    [AppRoutes.CLIENT_SUBSCRIPTION_DETAILS]: '/client-subscriptions/:id',
    [AppRoutes.CLIENT_SUBSCRIPTION_EDIT]: '/client-subscriptions/:id/edit',

    [AppRoutes.EXECUTORS]: '/executors',
    [AppRoutes.EXECUTOR_CREATE]: '/executors/new',
    [AppRoutes.EXECUTOR_EDIT]: '/executors/:id/edit',
    [AppRoutes.EXECUTOR_PASSPORT]: '/executors/:id/passport',
    [AppRoutes.EXECUTOR_DETAILS]: '/executors/:id',

    [AppRoutes.EXECUTOR_ADDRESS_CREATE]: '/executor-address/new',
    [AppRoutes.EXECUTOR_ADDRESS_DETAILS]: '/executor-address/:id',
    [AppRoutes.EXECUTOR_ADDRESS_EDIT]: '/executor-address/:id/edit',

    [AppRoutes.SUBSCRIPTIONS]: '/subscriptions',
    [AppRoutes.SUBSCRIPTION_CREATE]: '/subscriptions/new',
    [AppRoutes.SUBSCRIPTION_EDIT]: '/subscriptions/:id/edit',
    [AppRoutes.SUBSCRIPTION_DETAILS]: '/subscriptions/:id',

    [AppRoutes.CHATS]: '/chats',
    [AppRoutes.CHAT_DIALOGS]: '/chat-dialogs',
    [AppRoutes.USER_CHATS]: '/user-chats',

    [AppRoutes.VOX_SERVICES]: '/vox-services',

    [AppRoutes.BLOGS]: '/blogs',
    [AppRoutes.BLOG_CREATE]: '/blogs/new',
    [AppRoutes.BLOG_EDIT]: '/blogs/:id/edit',
    [AppRoutes.BLOG_DETAILS]: '/blogs/:id',

    [AppRoutes.PRODUCTS]: '/products',
    [AppRoutes.PRODUCT_CREATE]: '/products/new',
    [AppRoutes.PRODUCT_EDIT]: '/products/:id/edit',
    [AppRoutes.PRODUCT_DETAILS]: '/products/:id',

    [AppRoutes.PROMO_CODES]: '/promo-codes',
    [AppRoutes.PROMO_CODE_TEMPLATES]: '/promo-code-templates',
    [AppRoutes.PROMO_CODE_TEMPLATE_DETAILS]: '/promo-code-templates/:id',
    [AppRoutes.PROMO_CODE_TEMPLATE_CREATE]: '/promo-code-templates/new',
    [AppRoutes.PROMO_CODE_TEMPLATE_EDIT]: '/promo-code-templates/:id/edit',
    [AppRoutes.PROMO_CODE_PRINTINGS]: '/promo-code-printings',
    [AppRoutes.PROMO_CODE_PRINTING_DETAILS]: '/promo-code-printings/:id',
    [AppRoutes.PROMO_CODE_CREATE]: '/promo-codes/new',
    [AppRoutes.PROMO_CODE_EDIT]: '/promo-codes/:id/edit',
    [AppRoutes.PROMO_CODE_DETAILS]: '/promo-codes/:id',

    [AppRoutes.CASHBACK_LEVELS]: '/cashback-levels',
    [AppRoutes.CASHBACK_LEVEL_CREATE]: '/cashback-levels/new',
    [AppRoutes.CASHBACK_LEVEL_EDIT]: '/cashback-levels/:id/edit',
    [AppRoutes.CASHBACK_RULES]: '/cashback-rules',

    [AppRoutes.BONUS_ACCOUNTS]: '/bonus-accounts',
    [AppRoutes.BONUS_ACCOUNT_DETAILS]: '/bonus-accounts/:clientId',

    [AppRoutes.ORDERS]: '/orders',
    [AppRoutes.ORDER_PROBLEMS]: '/order-problems',
    [AppRoutes.ORDER_PROBLEM_DETAILS]: '/order-problems/:id',
    [AppRoutes.PROBLEM_ADDRESSES]: '/problem-addresses',
    [AppRoutes.PROBLEM_EXECUTORS]: '/problem-executors',
    [AppRoutes.PROBLEM_ADDRESS_DETAILS]: '/problem-addresses/:id',
    [AppRoutes.ORDER_DETAILS]: '/orders/:id',
    [AppRoutes.ORDER_CREATE]: '/orders/new',
    [AppRoutes.ORDER_EDIT]: '/orders/:id/edit',
    [AppRoutes.ORDER_CANCEL]: '/orders/:id/cancel',

    [AppRoutes.POLICIES]: '/policies',
    [AppRoutes.POLICY_CREATE]: '/policies/new',
    [AppRoutes.POLICY_EDIT]: '/policies/:id/edit',
    [AppRoutes.POLICY_DETAILS]: '/policies/:id',

    [AppRoutes.PRICE_LISTS]: '/price-lists',
    [AppRoutes.PRICE_LIST_DETAILS]: '/price-lists/:id',
    [AppRoutes.PRICE_LIST_CREATE]: '/price-lists/new',
    [AppRoutes.PRICE_LIST_EDIT]: '/price-lists/:id/edit',

    [AppRoutes.SETTINGS]: '/settings',
    [AppRoutes.TELEGRAM_SETTINGS]: '/telegram-settings',
    [AppRoutes.FEATURE_TOGGLES]: '/feature-toggles',
    [AppRoutes.APPLICATION_SETTINGS]: '/settings/parameters',
    [AppRoutes.CACHE_MANAGEMENT]: '/cache',
    [AppRoutes.SCHEDULER]: '/scheduler',
    [AppRoutes.CRON_JOB_DETAILS]: '/scheduler/:jobKey',
    [AppRoutes.CRON_JOB_EDIT]: '/scheduler/:jobKey/edit',
    [AppRoutes.MEMORY_DIAGNOSTICS]: '/memory-diagnostics',
    [AppRoutes.MESSAGE_SEND_STATISTICS]: '/message-send-statistics',
    [AppRoutes.ORDER_CANCELLATION_ANALYTICS]: '/order-cancellation-analytics',
    [AppRoutes.PUSH_TESTS]: '/push-tests',

    [AppRoutes.APP_VERSIONS]: '/app-versions',
    [AppRoutes.APP_VERSION_DETAILS]: '/app-versions/:id',
    [AppRoutes.APP_VERSION_EDIT]: '/app-versions/:id/edit',

    [AppRoutes.TAGS]: '/tags',
    [AppRoutes.TAG_EDIT]: '/tags/:tagType/edit',

    [AppRoutes.MESSAGE_TEMPLATES]: '/message-templates',
    [AppRoutes.MESSAGE_TEMPLATE_GROUP]: '/message-templates/groups/:group',
    [AppRoutes.MESSAGE_TEMPLATE_EDIT]: '/message-templates/:id/edit',
    [AppRoutes.USER_DIALOGS]: '/user-dialogs',
    [AppRoutes.USER_DIALOG_TEMPLATE_NEW]: '/user-dialogs/templates/new',
    [AppRoutes.USER_DIALOG_TEMPLATE]: '/user-dialogs/templates/:id',
    [AppRoutes.USER_DIALOG_BROADCAST_NEW]: '/user-dialogs/broadcasts/new',
    [AppRoutes.USER_DIALOG_BROADCAST]: '/user-dialogs/broadcasts/:id',
    [AppRoutes.NOTIFICATION_TEMPLATES]: '/notification-templates',
    [AppRoutes.NOTIFICATION_TEMPLATE_DETAILS]: '/notification-templates/:id',
    [AppRoutes.NOTIFICATION_TEMPLATE_EDIT]: '/notification-templates/:id/edit',

    [AppRoutes.ACCESS_MANAGEMENT]: '/access-management',

    [AppRoutes.NOT_FOUND]: '*',
};

export type AppRouteConfig = RouteProps & {
    allowedRoles?: readonly ApiUserRoleType[];
    accessRoute?: string;
};

export const routeConfig: Record<AppRoutes, AppRouteConfig> = {
    [AppRoutes.PROMOTION_BANNER_TEMPLATES]: {
        path: RoutePath.promotionBannerTemplates,
        element: <PromotionBannerTemplates />,
    },
    [AppRoutes.PROMOTION_BANNER_TEMPLATE_CREATE]: {
        path: RoutePath.promotionBannerTemplateCreate,
        element: <PromotionBannerTemplateForm />,
    },
    [AppRoutes.PROMOTION_BANNER_TEMPLATE_EDIT]: {
        path: RoutePath.promotionBannerTemplateEdit,
        element: <PromotionBannerTemplateForm />,
    },
    [AppRoutes.PROMOTION_BANNER_TEMPLATE_DETAILS]: {
        path: RoutePath.promotionBannerTemplateDetails,
        element: <PromotionBannerTemplateDetails />,
    },

    [AppRoutes.TASK_INDEX]: {
        path: RoutePath.taskIndex,
        element: <TaskIndexPage />,
    },
    [AppRoutes.OPERATOR_TASKS]: {
        path: RoutePath.operatorTasks,
        element: <OperatorTasksPage />,
    },

    [AppRoutes.AUTH]: {
        path: RoutePath.auth,
    },
    [AppRoutes.MAIN]: {
        path: RoutePath.main,
        element: <DashboardPage />,
    },

    [AppRoutes.CITIES]: {
        path: RoutePath.cities,
        element: <Cities />,
    },

    // [AppRoutes.PETS]: {
    //     path: RoutePath.pets,
    //     element: <CitiesPage />,
    // },
    [AppRoutes.PET_DETAILS]: {
        path: RoutePath.petDetails,
        element: <PetDetails />,
    },
    [AppRoutes.PET_CREATE]: {
        path: RoutePath.petCreate,
        element: <PetForm />,
    },
    [AppRoutes.PET_EDIT]: {
        path: RoutePath.petEdit,
        element: <PetForm />,
    },

    [AppRoutes.CLIENTS]: {
        path: RoutePath.clients,
        element: <Clients />,
    },
    [AppRoutes.CLIENT_DETAILS]: {
        path: RoutePath.clientDetails,
        element: <ClientDetails />,
    },
    [AppRoutes.CLIENT_EDIT]: {
        path: RoutePath.clientEdit,
        element: <ClientForm />,
    },
    [AppRoutes.CLIENT_CREATE]: {
        path: RoutePath.clientCreate,
        element: <ClientForm />,
    },

    [AppRoutes.CLIENT_ADDRESS_DETAILS]: {
        path: RoutePath.clientAddressDetails,
        element: <ClientAddressDetails />,
    },
    [AppRoutes.CLIENT_ADDRESS_CREATE]: {
        path: RoutePath.clientAddressCreate,
        element: <ClientAddressForm />,
    },
    [AppRoutes.CLIENT_ADDRESS_EDIT]: {
        path: RoutePath.clientAddressEdit,
        element: <ClientAddressForm />,
    },

    [AppRoutes.CLIENT_SUBSCRIPTION_DETAILS]: {
        path: RoutePath.clientSubscriptionDetails,
        element: <ClientSubscriptionDetails />,
    },
    [AppRoutes.CLIENT_SUBSCRIPTION_CREATE]: {
        path: RoutePath.clientSubscriptionCreate,
        element: <ClientSubscriptionForm />,
    },
    [AppRoutes.CLIENT_SUBSCRIPTION_EDIT]: {
        path: RoutePath.clientSubscriptionEdit,
        element: <ClientSubscriptionForm />,
    },

    [AppRoutes.EXECUTORS]: {
        path: RoutePath.executors,
        element: <Executors />,
    },
    [AppRoutes.EXECUTOR_DETAILS]: {
        path: RoutePath.executorDetails,
        element: <ExecutorDetails />,
    },
    [AppRoutes.EXECUTOR_EDIT]: {
        path: RoutePath.executorEdit,
        element: <ExecutorForm />,
    },
    [AppRoutes.EXECUTOR_CREATE]: {
        path: RoutePath.executorCreate,
        element: <ExecutorForm />,
    },
    [AppRoutes.EXECUTOR_PASSPORT]: {
        path: RoutePath.executorPassport,
        element: <ExecutorPassport />,
    },

    [AppRoutes.EXECUTOR_ADDRESS_DETAILS]: {
        path: RoutePath.executorAddressDetails,
        element: <ExecutorAddressDetails />,
    },
    [AppRoutes.EXECUTOR_ADDRESS_CREATE]: {
        path: RoutePath.executorAddressCreate,
        element: <ExecutorAddressForm />,
    },
    [AppRoutes.EXECUTOR_ADDRESS_EDIT]: {
        path: RoutePath.executorAddressEdit,
        element: <ExecutorAddressForm />,
    },

    [AppRoutes.SUBSCRIPTIONS]: {
        path: RoutePath.subscriptions,
        element: <Subscriptions />,
    },
    [AppRoutes.SUBSCRIPTION_DETAILS]: {
        path: RoutePath.subscriptionDetails,
        element: <SubscriptionDetails />,
    },
    [AppRoutes.SUBSCRIPTION_EDIT]: {
        path: RoutePath.subscriptionEdit,
        element: <SubscriptionForm />,
    },
    [AppRoutes.SUBSCRIPTION_CREATE]: {
        path: RoutePath.subscriptionCreate,
        element: <SubscriptionForm />,
    },

    [AppRoutes.CHATS]: {
        path: RoutePath.chats,
        element: <ChatPage />,
    },
    [AppRoutes.MEDIA_LIBRARY]: {
        path: RoutePath.mediaLibrary,
        element: <MediaLibraryPage />,
    },
    [AppRoutes.CHAT_REPLY_TEMPLATES]: {
        path: RoutePath.chatReplyTemplates,
        element: <ChatReplyTemplatesPage />,
    },
    [AppRoutes.CHAT_DIALOGS]: {
        path: RoutePath.chatDialogs,
        element: <ChatDialogPage />,
    },
    [AppRoutes.USER_CHATS]: {
        path: RoutePath.userChats,
        accessRoute: RoutePath.chats,
        element: <UserChatsPage />,
    },

    [AppRoutes.VOX_SERVICES]: {
        path: RoutePath['vox-services'],
        element: <VoxServicesPage />,
    },

    [AppRoutes.BLOGS]: {
        path: RoutePath.blogs,
        element: <Blogs />,
    },
    [AppRoutes.BLOG_DETAILS]: {
        path: RoutePath.blogDetails,
        element: <BlogDetails />,
    },
    [AppRoutes.BLOG_EDIT]: {
        path: RoutePath.blogEdit,
        element: <BlogForm />,
    },
    [AppRoutes.BLOG_CREATE]: {
        path: RoutePath.blogCreate,
        element: <BlogForm />,
    },

    [AppRoutes.PRODUCTS]: {
        path: RoutePath.products,
        element: <Products />,
    },
    [AppRoutes.PRODUCT_DETAILS]: {
        path: RoutePath.productDetails,
        element: <ProductDetails />,
    },
    [AppRoutes.PRODUCT_EDIT]: {
        path: RoutePath.productEdit,
        element: <ProductForm />,
    },
    [AppRoutes.PRODUCT_CREATE]: {
        path: RoutePath.productCreate,
        element: <ProductForm />,
    },

    [AppRoutes.ORDERS]: {
        path: RoutePath.orders,
        element: <Orders />,
    },
    [AppRoutes.ORDER_PROBLEMS]: {
        path: RoutePath.orderProblems,
        element: <OrderProblemsPage />,
    },
    [AppRoutes.PROBLEM_ADDRESSES]: {
        path: RoutePath.problemAddresses,
        element: <ProblemAddressesPage />,
    },
    [AppRoutes.PROBLEM_EXECUTORS]: {
        path: RoutePath.problemExecutors,
        element: <ProblemExecutorsPage />,
    },
    [AppRoutes.PROBLEM_ADDRESS_DETAILS]: {
        path: RoutePath.problemAddressDetails,
        element: <ProblemAddressDetailsPage />,
    },
    [AppRoutes.ORDER_PROBLEM_DETAILS]: {
        path: RoutePath.orderProblemDetails,
        element: <OrderProblemDetailsPage />,
    },
    [AppRoutes.ORDER_DETAILS]: {
        path: RoutePath.orderDetails,
        element: <OrderDetails />,
    },
    [AppRoutes.ORDER_CREATE]: {
        path: RoutePath.orderCreate,
        element: <OrderForm />,
    },
    [AppRoutes.ORDER_EDIT]: {
        path: RoutePath.orderEdit,
        element: <OrderForm />,
    },
    [AppRoutes.ORDER_CANCEL]: {
        path: RoutePath.orderCancel,
        element: <CancelOrderForm />,
    },

    [AppRoutes.SETTINGS]: {
        path: RoutePath.settings,
        element: <VoxSettingsPage />,
    },
    [AppRoutes.APPLICATION_SETTINGS]: {
        path: RoutePath.voxSettings,
        element: <Navigate
            to={RoutePath.settings}
            replace
        />,
    },
    [AppRoutes.TELEGRAM_SETTINGS]: {
        path: RoutePath.telegramSettings,
        element: <TelegramSettingsForm />,
    },
    [AppRoutes.CACHE_MANAGEMENT]: {
        path: RoutePath.cacheManagement,
        element: <CacheManagementPage />,
    },
    [AppRoutes.SCHEDULER]: {
        path: RoutePath.scheduler,
        element: <SchedulerPage />,
    },
    [AppRoutes.CRON_JOB_DETAILS]: {
        path: RoutePath.cronJobDetails,
        element: <CronJobDetailsPage />,
    },
    [AppRoutes.CRON_JOB_EDIT]: {
        path: RoutePath.cronJobEdit,
        element: <CronJobFormPage />,
    },
    [AppRoutes.FEATURE_TOGGLES]: {
        path: RoutePath.featureToggles,
        element: <FeatureTogglesPage />,
    },
    [AppRoutes.MEMORY_DIAGNOSTICS]: {
        path: RoutePath.memoryDiagnostics,
        element: <MemoryDiagnosticsPage />,
    },
    [AppRoutes.PUSH_TESTS]: {
        path: RoutePath.pushTests,
        element: <PushTestsPage />,
    },
    [AppRoutes.ORDER_CANCELLATION_ANALYTICS]: {
        path: RoutePath.orderCancellationAnalytics,
        element: <OrderCancellationAnalyticsPage />,
    },
    [AppRoutes.MESSAGE_SEND_STATISTICS]: {
        path: RoutePath.messageSendStatistics,
        element: <MessageSendStatisticsPage />,
    },

    [AppRoutes.APP_VERSIONS]: {
        path: RoutePath.appVersions,
        element: <AppVersions />,
    },
    [AppRoutes.APP_VERSION_DETAILS]: {
        path: RoutePath.appVersionDetails,
        element: <AppVersionDetails />,
    },
    [AppRoutes.APP_VERSION_EDIT]: {
        path: RoutePath.appVersionEdit,
        element: <AppVersionForm />,
    },

    [AppRoutes.TAGS]: {
        path: RoutePath.tags,
        element: <Tags />,
    },
    [AppRoutes.TAG_EDIT]: {
        path: RoutePath.tagEdit,
        element: <TagForm />,
    },

    [AppRoutes.MESSAGE_TEMPLATES]: {
        path: RoutePath.messageTemplates,
        element: <MessageTemplateGroupsPage />,
    },
    [AppRoutes.MESSAGE_TEMPLATE_GROUP]: {
        path: RoutePath.messageTemplateGroup,
        element: <MessageTemplateGroupPage />,
    },
    [AppRoutes.MESSAGE_TEMPLATE_EDIT]: {
        path: RoutePath.messageTemplateEdit,
        element: <MessageTemplateFormPage />,
    },
    [AppRoutes.USER_DIALOGS]: {
        path: RoutePath.userDialogs,
        element: <UserDialogsPage />
    },
    [AppRoutes.USER_DIALOG_TEMPLATE_NEW]: {
        path: RoutePath.userDialogTemplateNew,
        element: <DialogTemplateFormPage />
    },
    [AppRoutes.USER_DIALOG_TEMPLATE]: {
        path: RoutePath.userDialogTemplate,
        element: <DialogTemplateFormPage />
    },
    [AppRoutes.USER_DIALOG_BROADCAST_NEW]: {
        path: RoutePath.userDialogBroadcastNew,
        element: <DialogBroadcastFormPage />
    },
    [AppRoutes.USER_DIALOG_BROADCAST]: {
        path: RoutePath.userDialogBroadcast,
        element: <DialogBroadcastDetailsPage />
    },
    [AppRoutes.NOTIFICATION_TEMPLATES]: {
        path: RoutePath.notificationTemplates,
        element: <NotificationTemplates />
    },

    [AppRoutes.NOTIFICATION_TEMPLATE_DETAILS]: {
        path: RoutePath.notificationTemplateDetails,
        element: <NotificationTemplateDetails />
    },

    [AppRoutes.NOTIFICATION_TEMPLATE_EDIT]: {
        path: RoutePath.notificationTemplateEdit,
        element: <NotificationTemplateForm />
    },

    [AppRoutes.ACCESS_MANAGEMENT]: {
        path: RoutePath.accessManagement,
        element: <AccessManagementPage />,
        allowedRoles: [ApiUserRole.SuperAdmin, ApiUserRole.Developer],
    },

    [AppRoutes.POLICIES]: {
        path: RoutePath.policies,
        element: <Policies />,
    },
    [AppRoutes.POLICY_DETAILS]: {
        path: RoutePath.policyDetails,
        element: <PolicyDetails />,
    },
    [AppRoutes.POLICY_EDIT]: {
        path: RoutePath.policyEdit,
        element: <PolicyForm />,
    },
    [AppRoutes.POLICY_CREATE]: {
        path: RoutePath.policyCreate,
        element: <PolicyForm />,
    },

    //#region PromoCode

    [AppRoutes.PROMO_CODE_TEMPLATES]: {
        path: RoutePath.promoCodeTemplates,
        element: <PromoCodeTemplatesPage />
    },
    [AppRoutes.PROMO_CODE_TEMPLATE_DETAILS]: {
        path: RoutePath.promoCodeTemplateDetails,
        element: <PromoCodeTemplateDetailsPage />
    },
    [AppRoutes.PROMO_CODE_TEMPLATE_CREATE]: {
        path: RoutePath.promoCodeTemplateCreate,
        element: <PromoCodeTemplateFormPage />
    },
    [AppRoutes.PROMO_CODE_TEMPLATE_EDIT]: {
        path: RoutePath.promoCodeTemplateEdit,
        element: <PromoCodeTemplateFormPage />
    },
    [AppRoutes.PROMO_CODE_PRINTINGS]: {
        path: RoutePath.promoCodePrintings,
        element: <PromoCodePrintingsPage />
    },
    [AppRoutes.PROMO_CODE_PRINTING_DETAILS]: {
        path: RoutePath.promoCodePrintingDetails,
        element: <PromoCodePrintingDetailsPage />
    },

    [AppRoutes.PROMO_CODES]: {
        path: RoutePath.promoCodes,
        element: <PromoCodes />,
    },
    [AppRoutes.PROMO_CODE_DETAILS]: {
        path: RoutePath.promoCodeDetails,
        element: <PromoCodeDetails />,
    },
    [AppRoutes.PROMO_CODE_EDIT]: {
        path: RoutePath.promoCodeEdit,
        element: <PromoCodeForm />,
    },
    [AppRoutes.PROMO_CODE_CREATE]: {
        path: RoutePath.promoCodeCreate,
        element: <PromoCodeForm />,
    },

    //#endregion

    [AppRoutes.CASHBACK_LEVELS]: {
        path: RoutePath.cashbackLevels,
        element: <CashbackLevels />,
    },
    [AppRoutes.CASHBACK_LEVEL_CREATE]: {
        path: RoutePath.cashbackLevelCreate,
        element: <CashbackLevelForm />,
    },
    [AppRoutes.CASHBACK_LEVEL_EDIT]: {
        path: RoutePath.cashbackLevelEdit,
        element: <CashbackLevelForm />,
    },

    [AppRoutes.BONUS_ACCOUNTS]: {
        path: RoutePath.bonusAccounts,
        element: <BonusAccounts />,
    },
    [AppRoutes.CASHBACK_RULES]: {
        path: RoutePath.cashbackRules,
        element: <CashbackRulesPage />,
    },
    [AppRoutes.BONUS_ACCOUNT_DETAILS]: {
        path: RoutePath.bonusAccountDetails,
        element: <BonusAccountDetails />,
    },

    [AppRoutes.PRICE_LISTS]: {
        path: RoutePath.priceLists,
        element: <PriceLists />,
    },
    [AppRoutes.PRICE_LIST_DETAILS]: {
        path: RoutePath.priceListDetails,
        element: <PriceListDetails />,
    },
    [AppRoutes.PRICE_LIST_EDIT]: {
        path: RoutePath.priceListEdit,
        element: <PriceListForm />,
    },
    [AppRoutes.PRICE_LIST_CREATE]: {
        path: RoutePath.priceListCreate,
        element: <PriceListForm />,
    },

    [AppRoutes.NOT_FOUND]: {
        path: RoutePath.not_found,
        element: <Navigate
            replace
            to="/"
        />,
    },
};
